import { sbomCpeFallbackFetchers } from '../../../../../shared/fetchers';
import type { VulnIssue } from '../../../../../shared/issuesV2';

/*
  Restrict the CPE treatment to the SBOM ingestion fallbacks, whose vulnerabilities genuinely do
  arrive by CPE match, so a third-party dep that merely carries a CPE in its SBOM metadata
  doesn't get it.
*/
export const isIssueDetectedViaCpe = (issue: VulnIssue): boolean => {
  const packageManager = issue.source?.packageManager;

  return !!packageManager
    && sbomCpeFallbackFetchers.has(packageManager)
    && 'cpes' in issue
    && !!issue.cpes?.length;
};
